module.exports = __webpack_public_path__ + "static/media/pay-applepay-on.f1c34759.png";